import { Component, Mixins, Prop } from 'vue-property-decorator';
import { Line } from 'vue-chartjs';
import { LineChartDatasetInterface, UserStatisticInterface } from '@/services/QC-V2/statistic/interfaces';
import { Chart } from 'chart.js';

@Component({})
export default class LineChart extends Mixins(Line) {
  @Prop() private title!: string;
  @Prop() private footerText!: string;
  @Prop() private labels: string[];
  @Prop() private dataSets!: LineChartDatasetInterface[];

  public mounted(): void {
    this.createChart();
  }

  private createChart(): void {
    this.renderChart({
        labels: this.labels.map((dateLabel) => new Date(dateLabel).toLocaleString('en-gb').substr(0, 10)),
        datasets: this.dataSets,
      },
      {
        responsive: true,
        title: {
          text: this.title,
          display: true,
        },
        elements: {
          point: {
            radius: 5,
            pointStyle: 'circle',
            hitRadius: 100,
          },
        },
        scales: {
          yAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: 'Count',
              },
              ticks: {
                beginAtZero: true,
                stepSize: 1,
              },
            },
          ],
          xAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: this.footerText || '',
              },
            },
          ],
        },
        tooltips: {
          callbacks: {
            afterBody(item: Chart.ChartTooltipItem[], data: Chart.ChartData): string | string[] {
              const count = item.values().next().value.yLabel;
              const dataIndex = item.values().next().value.index;
              const dataSetIndex = item.values().next().value.datasetIndex;

              return data.datasets ? (data.datasets[dataSetIndex] as LineChartDatasetInterface)
                .blobTexts[dataIndex] : '';
            },
          },
        },
      },
    );
  }
}
